// This icon file is generated automatically.
var PItalicOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M10.47.5H3.72a.13.13 0 00-.13.13v1c0 .06.06.12.13.12h2.83l-2.44 8.5H1.58a.13.13 0 00-.13.13v1c0 .06.06.12.13.12h6.75c.07 0 .12-.06.12-.13v-1a.13.13 0 00-.12-.12H5.4l2.44-8.5h2.62c.07 0 .12-.06.12-.13v-1a.13.13 0 00-.12-.12z", "fill-rule": "nonzero" } }] }, "name": "p-italic", "theme": "outlined" };
export default PItalicOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PItalicOutlined.js
// module id = 3475
// module chunks = 0